import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const SdcardType = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('sd_item3'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])

    return <div className="App">
        <div style={{ width: '100%' }}>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#333333', marginTop: 15, lineHeight: '22px', fontWeight: '500' }}>{t('sd_space_faq2')}</span>
                <span style={{ fontSize: 14, color: '#333333', marginTop: 15, lineHeight: '22px' }}>{t('sd_space_faq3')}</span>
            </div>
        </div>
    </div>
}

export default SdcardType